/* eslint-disable global-require */
import isString from 'lodash/isString';
import PubSub from 'pubsub-js';
import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';
import initI18n from './i18n';
import { endpoints, setBaseURL } from './utilities';

export default class VA {
  constructor(config) {
    this.config = config;

    // Path for chunks and translation files
    const serverPath = this.config.appFilePath.split('va.js')[0];
    // eslint-disable-next-line camelcase
    __webpack_public_path__ = serverPath;

    initI18n(this.config.i18n, this.config.source, serverPath);

    if (this.config.apiURL) {
      setBaseURL(this.config.apiURL);
    }

    if (this.config.endpoints) {
      endpoints.override(this.config.endpoints);
    }

    let rootElement = null;

    if (isString(this.config.selector)) {
      rootElement = document.querySelector(this.config.selector);
    }

    if (!rootElement) {
      rootElement = document.createElement('div');
      document.body.appendChild(rootElement);
    }

    this.rootElement = rootElement;
  }

  emit = (message, data) => {
    PubSub.publish(message, data);
  };

  on = (event, cb) => {
    PubSub.subscribe(event, cb);
  };

  unsubscribe = event => {
    PubSub.unsubscribe(event);
  };

  clearAllSubscriptions = () => {
    PubSub.clearAllSubscriptions();
  };

  render() {
    ReactDOM.render(<App config={this.config} />, this.rootElement);
  }

  unmount() {
    this.clearAllSubscriptions();
    ReactDOM.unmountComponentAtNode(document.querySelector(this.rootElement));
  }
}

if (process.env.NODE_ENV === 'development') {
  require('./dev').default(VA);
}
